// extracted by mini-css-extract-plugin
export default {"view":"MobilePreview_view__kimQS"};